/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import * as import0 from '../../../../../app/subapps/tour-of-heroes/team/player-edit.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../app/subapps/tour-of-heroes/services/team.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '../../../../../app/subapps/tour-of-heroes/providers/team-provider.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '../../../../../app/nav/sb-router.service';
import * as import13 from '@angular/core/src/linker/view_container';
import * as import14 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import15 from '@angular/core/src/linker/template_ref';
import * as import16 from '@angular/common/src/directives/ng_if';
import * as import17 from '../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import18 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import19 from '../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import20 from '../../../../node_modules/@angular/forms/src/directives/validators.ngfactory';
import * as import21 from '../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import22 from '../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import23 from '../../../../node_modules/@angular/router/src/directives/router_link.ngfactory';
import * as import24 from '@angular/core/src/linker/element_ref';
import * as import25 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import26 from '@angular/router/src/router';
import * as import27 from '@angular/forms/src/directives/default_value_accessor';
import * as import28 from '@angular/forms/src/directives/validators';
import * as import29 from '@angular/forms/src/validators';
import * as import30 from '@angular/forms/src/directives/control_value_accessor';
import * as import31 from '@angular/forms/src/directives/ng_model';
import * as import32 from '@angular/forms/src/directives/ng_control';
import * as import33 from '@angular/forms/src/directives/ng_control_status';
import * as import34 from '@angular/common/src/directives/ng_for';
import * as import35 from '@angular/router/src/directives/router_link';
import * as import36 from '@angular/forms/src/directives/ng_form';
import * as import37 from '@angular/forms/src/directives/control_container';
import * as import38 from '../../../../node_modules/@angular/forms/src/directives/radio_control_value_accessor.ngfactory';
import * as import39 from '@angular/forms/src/directives/radio_control_value_accessor';
export var Wrapper_PlayerEditComponent = (function () {
    function Wrapper_PlayerEditComponent(p0, p1, p2) {
        this._changed = false;
        this.context = new import0.PlayerEditComponent(p0, p1, p2);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_PlayerEditComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_PlayerEditComponent.prototype.ngOnDestroy = function () {
        this.context.ngOnDestroy();
    };
    Wrapper_PlayerEditComponent.prototype.check_player = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.player = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_PlayerEditComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_PlayerEditComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_PlayerEditComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_PlayerEditComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_PlayerEditComponent;
}());
var renderType_PlayerEditComponent_Host = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.None, [], {});
var View_PlayerEditComponent_Host0 = (function (_super) {
    __extends(View_PlayerEditComponent_Host0, _super);
    function View_PlayerEditComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_PlayerEditComponent_Host0, renderType_PlayerEditComponent_Host, import7.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways);
    }
    View_PlayerEditComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'player-edit', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_PlayerEditComponent0(this.viewUtils, this, 0, this._el_0);
        this._TeamService_0_3 = new import6.TeamService(this.injectorGet(import10.TeamProvider, this.parentIndex));
        this._PlayerEditComponent_0_4 = new Wrapper_PlayerEditComponent(this.injectorGet(import11.ActivatedRoute, this.parentIndex), this.injectorGet(import12.SbRouterService, this.parentIndex), this._TeamService_0_3);
        this.compView_0.create(this._PlayerEditComponent_0_4.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import9.ComponentRef_(0, this, this._el_0, this._PlayerEditComponent_0_4.context);
    };
    View_PlayerEditComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import6.TeamService) && (0 === requestNodeIndex))) {
            return this._TeamService_0_3;
        }
        if (((token === import0.PlayerEditComponent) && (0 === requestNodeIndex))) {
            return this._PlayerEditComponent_0_4.context;
        }
        return notFoundResult;
    };
    View_PlayerEditComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._PlayerEditComponent_0_4.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.detectChanges(throwOnChange);
    };
    View_PlayerEditComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
        this._PlayerEditComponent_0_4.ngOnDestroy();
    };
    View_PlayerEditComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_PlayerEditComponent_Host0;
}(import2.AppView));
export var PlayerEditComponentNgFactory = new import9.ComponentFactory('player-edit', View_PlayerEditComponent_Host0, import0.PlayerEditComponent);
var styles_PlayerEditComponent = [];
var renderType_PlayerEditComponent = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.None, styles_PlayerEditComponent, {});
export var View_PlayerEditComponent0 = (function (_super) {
    __extends(View_PlayerEditComponent0, _super);
    function View_PlayerEditComponent0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_PlayerEditComponent0, renderType_PlayerEditComponent, import7.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways);
    }
    View_PlayerEditComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._anchor_0 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._vc_0 = new import13.ViewContainer(0, null, this, this._anchor_0);
        this._TemplateRef_0_5 = new import15.TemplateRef_(this, 0, this._anchor_0);
        this._NgIf_0_6 = new import14.Wrapper_NgIf(this._vc_0.vcRef, this._TemplateRef_0_5);
        this.init(null, (this.renderer.directRenderer ? null : [this._anchor_0]), null);
        return null;
    };
    View_PlayerEditComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import15.TemplateRef) && (0 === requestNodeIndex))) {
            return this._TemplateRef_0_5;
        }
        if (((token === import16.NgIf) && (0 === requestNodeIndex))) {
            return this._NgIf_0_6.context;
        }
        return notFoundResult;
    };
    View_PlayerEditComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.context.player;
        this._NgIf_0_6.check_ngIf(currVal_0_0_0, throwOnChange, false);
        this._NgIf_0_6.ngDoCheck(this, this._anchor_0, throwOnChange);
        this._vc_0.detectChangesInNestedViews(throwOnChange);
    };
    View_PlayerEditComponent0.prototype.destroyInternal = function () {
        this._vc_0.destroyNestedViews();
    };
    View_PlayerEditComponent0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 0)) {
            return new View_PlayerEditComponent1(this.viewUtils, this, 0, this._anchor_0, this._vc_0);
        }
        return null;
    };
    return View_PlayerEditComponent0;
}(import2.AppView));
var View_PlayerEditComponent1 = (function (_super) {
    __extends(View_PlayerEditComponent1, _super);
    function View_PlayerEditComponent1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        _super.call(this, View_PlayerEditComponent1, renderType_PlayerEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways, declaredViewContainer);
        this._expr_106 = import1.UNINITIALIZED;
        this._expr_107 = import1.UNINITIALIZED;
        this._expr_108 = import1.UNINITIALIZED;
        this._expr_109 = import1.UNINITIALIZED;
        this._arr_110 = import3.pureProxy1(function (p0) {
            return [p0];
        });
        this._expr_111 = import1.UNINITIALIZED;
    }
    View_PlayerEditComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'form', new import3.InlineArray2(2, 'class', 'form-horizontal'), null);
        this._NgForm_0_3 = new import17.Wrapper_NgForm(null, null);
        this._ControlContainer_0_4 = this._NgForm_0_3.context;
        this._NgControlStatusGroup_0_5 = new import18.Wrapper_NgControlStatusGroup(this._ControlContainer_0_4);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'form-group'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_4 = import3.createRenderElement(this.renderer, this._el_2, 'label', new import3.InlineArray4(4, 'class', 'col-md-2 control-label', 'for', 'playerFirstName'), null);
        this._text_5 = this.renderer.createText(this._el_4, 'First name', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_7 = import3.createRenderElement(this.renderer, this._el_2, 'div', new import3.InlineArray2(2, 'class', 'col-md-6'), null);
        this._text_8 = this.renderer.createText(this._el_7, '\n            ', null);
        this._el_9 = import3.createRenderElement(this.renderer, this._el_7, 'input', new import3.InlineArray16(14, 'class', 'form-control', 'id', 'playerFirstName', 'name', 'name', 'ngModel', '', 'placeholder', 'First name', 'required', '', 'type', 'text'), null);
        this._DefaultValueAccessor_9_3 = new import19.Wrapper_DefaultValueAccessor(this.renderer, new import24.ElementRef(this._el_9));
        this._RequiredValidator_9_4 = new import20.Wrapper_RequiredValidator();
        this._NG_VALIDATORS_9_5 = [this._RequiredValidator_9_4.context];
        this._NG_VALUE_ACCESSOR_9_6 = [this._DefaultValueAccessor_9_3.context];
        this._NgModel_9_7 = new import21.Wrapper_NgModel(this._ControlContainer_0_4, this._NG_VALIDATORS_9_5, null, this._NG_VALUE_ACCESSOR_9_6);
        this._NgControl_9_8 = this._NgModel_9_7.context;
        this._NgControlStatus_9_9 = new import18.Wrapper_NgControlStatus(this._NgControl_9_8);
        this._text_10 = this.renderer.createText(this._el_7, '\n        ', null);
        this._text_11 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_12 = import3.createRenderElement(this.renderer, this._el_2, 'span', new import3.InlineArray2(2, 'class', 'col-md-4'), null);
        this._text_13 = this.renderer.createText(this._el_12, '', null);
        this._text_14 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_15 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_16 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'form-group'), null);
        this._text_17 = this.renderer.createText(this._el_16, '\n        ', null);
        this._el_18 = import3.createRenderElement(this.renderer, this._el_16, 'label', new import3.InlineArray4(4, 'class', 'col-md-2 control-label', 'for', 'playerLastName'), null);
        this._text_19 = this.renderer.createText(this._el_18, 'Last name', null);
        this._text_20 = this.renderer.createText(this._el_16, '\n        ', null);
        this._el_21 = import3.createRenderElement(this.renderer, this._el_16, 'div', new import3.InlineArray2(2, 'class', 'col-md-6'), null);
        this._text_22 = this.renderer.createText(this._el_21, '\n            ', null);
        this._el_23 = import3.createRenderElement(this.renderer, this._el_21, 'input', new import3.InlineArray16(14, 'class', ' form-control ', 'id', 'playerLastName', 'name', 'lastName', 'ngModel', '', 'placeholder', 'Last name ', 'required', '', 'type', 'text'), null);
        this._DefaultValueAccessor_23_3 = new import19.Wrapper_DefaultValueAccessor(this.renderer, new import24.ElementRef(this._el_23));
        this._RequiredValidator_23_4 = new import20.Wrapper_RequiredValidator();
        this._NG_VALIDATORS_23_5 = [this._RequiredValidator_23_4.context];
        this._NG_VALUE_ACCESSOR_23_6 = [this._DefaultValueAccessor_23_3.context];
        this._NgModel_23_7 = new import21.Wrapper_NgModel(this._ControlContainer_0_4, this._NG_VALIDATORS_23_5, null, this._NG_VALUE_ACCESSOR_23_6);
        this._NgControl_23_8 = this._NgModel_23_7.context;
        this._NgControlStatus_23_9 = new import18.Wrapper_NgControlStatus(this._NgControl_23_8);
        this._text_24 = this.renderer.createText(this._el_21, '\n        ', null);
        this._text_25 = this.renderer.createText(this._el_16, '\n        ', null);
        this._el_26 = import3.createRenderElement(this.renderer, this._el_16, 'span', new import3.InlineArray2(2, 'class', 'col-md-4'), null);
        this._text_27 = this.renderer.createText(this._el_26, '', null);
        this._text_28 = this.renderer.createText(this._el_16, '\n    ', null);
        this._text_29 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_30 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_31 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_32 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_33 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_34 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_35 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_36 = this.renderer.createText(this._el_0, '\n    ', null);
        this._text_37 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_38 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'form-group'), null);
        this._text_39 = this.renderer.createText(this._el_38, '\n        ', null);
        this._el_40 = import3.createRenderElement(this.renderer, this._el_38, 'label', new import3.InlineArray2(2, 'class', 'col-md-2 control-label'), null);
        this._text_41 = this.renderer.createText(this._el_40, 'Gender', null);
        this._text_42 = this.renderer.createText(this._el_38, '\n        ', null);
        this._el_43 = import3.createRenderElement(this.renderer, this._el_38, 'div', new import3.InlineArray2(2, 'class', 'col-md-6'), null);
        this._text_44 = this.renderer.createText(this._el_43, '\n            ', null);
        this._anchor_45 = this.renderer.createTemplateAnchor(this._el_43, null);
        this._vc_45 = new import13.ViewContainer(45, 43, this, this._anchor_45);
        this._TemplateRef_45_5 = new import15.TemplateRef_(this, 45, this._anchor_45);
        this._NgFor_45_6 = new import22.Wrapper_NgFor(this._vc_45.vcRef, this._TemplateRef_45_5, this.parentView.injectorGet(import25.IterableDiffers, this.parentIndex), this.parentView.ref);
        this._text_46 = this.renderer.createText(this._el_43, '\n        ', null);
        this._text_47 = this.renderer.createText(this._el_38, '\n        ', null);
        this._el_48 = import3.createRenderElement(this.renderer, this._el_38, 'span', new import3.InlineArray2(2, 'class', 'col-md-4'), null);
        this._text_49 = this.renderer.createText(this._el_48, '', null);
        this._text_50 = this.renderer.createText(this._el_38, '\n    ', null);
        this._text_51 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_52 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'form-group'), null);
        this._text_53 = this.renderer.createText(this._el_52, '\n        ', null);
        this._el_54 = import3.createRenderElement(this.renderer, this._el_52, 'label', new import3.InlineArray4(4, 'class', 'col-md-2 control-label', 'for', 'playerEmail'), null);
        this._text_55 = this.renderer.createText(this._el_54, 'Email', null);
        this._text_56 = this.renderer.createText(this._el_52, '\n        ', null);
        this._el_57 = import3.createRenderElement(this.renderer, this._el_52, 'div', new import3.InlineArray2(2, 'class', 'col-md-6'), null);
        this._text_58 = this.renderer.createText(this._el_57, '\n            ', null);
        this._el_59 = import3.createRenderElement(this.renderer, this._el_57, 'input', new import3.InlineArray16(16, 'class', ' form-control ', 'id', 'playerEmail', 'name', 'email', 'ngModel', '', 'pattern', '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', 'placeholder', 'Email input', 'required', '', 'type', 'email'), null);
        this._DefaultValueAccessor_59_3 = new import19.Wrapper_DefaultValueAccessor(this.renderer, new import24.ElementRef(this._el_59));
        this._RequiredValidator_59_4 = new import20.Wrapper_RequiredValidator();
        this._PatternValidator_59_5 = new import20.Wrapper_PatternValidator();
        this._NG_VALIDATORS_59_6 = [
            this._RequiredValidator_59_4.context,
            this._PatternValidator_59_5.context
        ];
        this._NG_VALUE_ACCESSOR_59_7 = [this._DefaultValueAccessor_59_3.context];
        this._NgModel_59_8 = new import21.Wrapper_NgModel(this._ControlContainer_0_4, this._NG_VALIDATORS_59_6, null, this._NG_VALUE_ACCESSOR_59_7);
        this._NgControl_59_9 = this._NgModel_59_8.context;
        this._NgControlStatus_59_10 = new import18.Wrapper_NgControlStatus(this._NgControl_59_9);
        this._text_60 = this.renderer.createText(this._el_57, '\n        ', null);
        this._text_61 = this.renderer.createText(this._el_52, '\n        ', null);
        this._el_62 = import3.createRenderElement(this.renderer, this._el_52, 'span', new import3.InlineArray2(2, 'class', 'col-md-4'), null);
        this._text_63 = this.renderer.createText(this._el_62, '', null);
        this._text_64 = this.renderer.createText(this._el_52, '\n    ', null);
        this._text_65 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_66 = import3.createRenderElement(this.renderer, this._el_0, 'button', new import3.InlineArray2(2, 'class', 'btn btn-default '), null);
        this._RouterLink_66_3 = new import23.Wrapper_RouterLink(this.parentView.injectorGet(import26.Router, this.parentIndex), this.parentView.injectorGet(import11.ActivatedRoute, this.parentIndex));
        this._text_67 = this.renderer.createText(this._el_66, 'Back', null);
        this._text_68 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_69 = import3.createRenderElement(this.renderer, this._el_0, 'button', new import3.InlineArray4(4, 'class', 'btn btn-primary', 'type', 'submit'), null);
        this._text_70 = this.renderer.createText(this._el_69, 'Save', null);
        this._text_71 = this.renderer.createText(this._el_0, '\n    ', null);
        this._anchor_72 = this.renderer.createTemplateAnchor(this._el_0, null);
        this._vc_72 = new import13.ViewContainer(72, 0, this, this._anchor_72);
        this._TemplateRef_72_5 = new import15.TemplateRef_(this, 72, this._anchor_72);
        this._NgIf_72_6 = new import14.Wrapper_NgIf(this._vc_72.vcRef, this._TemplateRef_72_5);
        this._text_73 = this.renderer.createText(this._el_0, '\n', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray8(6, 'ngSubmit', null, 'submit', null, 'reset', null), this.eventHandler(this.handleEvent_0));
        this._NgForm_0_3.subscribe(this, this.eventHandler(this.handleEvent_0), true);
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_9, new import3.InlineArray8(6, 'ngModelChange', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_9));
        this._NgModel_9_7.subscribe(this, this.eventHandler(this.handleEvent_9), true);
        var disposable_2 = import3.subscribeToRenderElement(this, this._el_23, new import3.InlineArray8(6, 'ngModelChange', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_23));
        this._NgModel_23_7.subscribe(this, this.eventHandler(this.handleEvent_23), true);
        var disposable_3 = import3.subscribeToRenderElement(this, this._el_59, new import3.InlineArray8(6, 'ngModelChange', null, 'input', null, 'blur', null), this.eventHandler(this.handleEvent_59));
        this._NgModel_59_8.subscribe(this, this.eventHandler(this.handleEvent_59), true);
        var disposable_4 = import3.subscribeToRenderElement(this, this._el_66, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_66));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._el_9,
            this._text_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._text_14,
            this._text_15,
            this._el_16,
            this._text_17,
            this._el_18,
            this._text_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._el_26,
            this._text_27,
            this._text_28,
            this._text_29,
            this._text_30,
            this._text_31,
            this._text_32,
            this._text_33,
            this._text_34,
            this._text_35,
            this._text_36,
            this._text_37,
            this._el_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._text_42,
            this._el_43,
            this._text_44,
            this._anchor_45,
            this._text_46,
            this._text_47,
            this._el_48,
            this._text_49,
            this._text_50,
            this._text_51,
            this._el_52,
            this._text_53,
            this._el_54,
            this._text_55,
            this._text_56,
            this._el_57,
            this._text_58,
            this._el_59,
            this._text_60,
            this._text_61,
            this._el_62,
            this._text_63,
            this._text_64,
            this._text_65,
            this._el_66,
            this._text_67,
            this._text_68,
            this._el_69,
            this._text_70,
            this._text_71,
            this._anchor_72,
            this._text_73
        ]), [
            disposable_0,
            disposable_1,
            disposable_2,
            disposable_3,
            disposable_4
        ]);
        return null;
    };
    View_PlayerEditComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.DefaultValueAccessor) && (9 === requestNodeIndex))) {
            return this._DefaultValueAccessor_9_3.context;
        }
        if (((token === import28.RequiredValidator) && (9 === requestNodeIndex))) {
            return this._RequiredValidator_9_4.context;
        }
        if (((token === import29.NG_VALIDATORS) && (9 === requestNodeIndex))) {
            return this._NG_VALIDATORS_9_5;
        }
        if (((token === import30.NG_VALUE_ACCESSOR) && (9 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_9_6;
        }
        if (((token === import31.NgModel) && (9 === requestNodeIndex))) {
            return this._NgModel_9_7.context;
        }
        if (((token === import32.NgControl) && (9 === requestNodeIndex))) {
            return this._NgControl_9_8;
        }
        if (((token === import33.NgControlStatus) && (9 === requestNodeIndex))) {
            return this._NgControlStatus_9_9.context;
        }
        if (((token === import27.DefaultValueAccessor) && (23 === requestNodeIndex))) {
            return this._DefaultValueAccessor_23_3.context;
        }
        if (((token === import28.RequiredValidator) && (23 === requestNodeIndex))) {
            return this._RequiredValidator_23_4.context;
        }
        if (((token === import29.NG_VALIDATORS) && (23 === requestNodeIndex))) {
            return this._NG_VALIDATORS_23_5;
        }
        if (((token === import30.NG_VALUE_ACCESSOR) && (23 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_23_6;
        }
        if (((token === import31.NgModel) && (23 === requestNodeIndex))) {
            return this._NgModel_23_7.context;
        }
        if (((token === import32.NgControl) && (23 === requestNodeIndex))) {
            return this._NgControl_23_8;
        }
        if (((token === import33.NgControlStatus) && (23 === requestNodeIndex))) {
            return this._NgControlStatus_23_9.context;
        }
        if (((token === import15.TemplateRef) && (45 === requestNodeIndex))) {
            return this._TemplateRef_45_5;
        }
        if (((token === import34.NgFor) && (45 === requestNodeIndex))) {
            return this._NgFor_45_6.context;
        }
        if (((token === import27.DefaultValueAccessor) && (59 === requestNodeIndex))) {
            return this._DefaultValueAccessor_59_3.context;
        }
        if (((token === import28.RequiredValidator) && (59 === requestNodeIndex))) {
            return this._RequiredValidator_59_4.context;
        }
        if (((token === import28.PatternValidator) && (59 === requestNodeIndex))) {
            return this._PatternValidator_59_5.context;
        }
        if (((token === import29.NG_VALIDATORS) && (59 === requestNodeIndex))) {
            return this._NG_VALIDATORS_59_6;
        }
        if (((token === import30.NG_VALUE_ACCESSOR) && (59 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_59_7;
        }
        if (((token === import31.NgModel) && (59 === requestNodeIndex))) {
            return this._NgModel_59_8.context;
        }
        if (((token === import32.NgControl) && (59 === requestNodeIndex))) {
            return this._NgControl_59_9;
        }
        if (((token === import33.NgControlStatus) && (59 === requestNodeIndex))) {
            return this._NgControlStatus_59_10.context;
        }
        if (((token === import35.RouterLink) && ((66 <= requestNodeIndex) && (requestNodeIndex <= 67)))) {
            return this._RouterLink_66_3.context;
        }
        if (((token === import15.TemplateRef) && (72 === requestNodeIndex))) {
            return this._TemplateRef_72_5;
        }
        if (((token === import16.NgIf) && (72 === requestNodeIndex))) {
            return this._NgIf_72_6.context;
        }
        if (((token === import36.NgForm) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 73)))) {
            return this._NgForm_0_3.context;
        }
        if (((token === import37.ControlContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 73)))) {
            return this._ControlContainer_0_4;
        }
        if (((token === import33.NgControlStatusGroup) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 73)))) {
            return this._NgControlStatusGroup_0_5.context;
        }
        return notFoundResult;
    };
    View_PlayerEditComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        this._NgForm_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this._NgControlStatusGroup_0_5.ngDoCheck(this, this._el_0, throwOnChange);
        this._DefaultValueAccessor_9_3.ngDoCheck(this, this._el_9, throwOnChange);
        var currVal_9_1_0 = '';
        this._RequiredValidator_9_4.check_required(currVal_9_1_0, throwOnChange, false);
        this._RequiredValidator_9_4.ngDoCheck(this, this._el_9, throwOnChange);
        var currVal_9_2_0 = 'name';
        this._NgModel_9_7.check_name(currVal_9_2_0, throwOnChange, false);
        var currVal_9_2_1 = this.parentView.context.player.name;
        this._NgModel_9_7.check_model(currVal_9_2_1, throwOnChange, false);
        this._NgModel_9_7.ngDoCheck(this, this._el_9, throwOnChange);
        this._NgControlStatus_9_9.ngDoCheck(this, this._el_9, throwOnChange);
        this._DefaultValueAccessor_23_3.ngDoCheck(this, this._el_23, throwOnChange);
        var currVal_23_1_0 = '';
        this._RequiredValidator_23_4.check_required(currVal_23_1_0, throwOnChange, false);
        this._RequiredValidator_23_4.ngDoCheck(this, this._el_23, throwOnChange);
        var currVal_23_2_0 = 'lastName';
        this._NgModel_23_7.check_name(currVal_23_2_0, throwOnChange, false);
        var currVal_23_2_1 = this.parentView.context.player.lastName;
        this._NgModel_23_7.check_model(currVal_23_2_1, throwOnChange, false);
        this._NgModel_23_7.ngDoCheck(this, this._el_23, throwOnChange);
        this._NgControlStatus_23_9.ngDoCheck(this, this._el_23, throwOnChange);
        var currVal_45_0_0 = this.parentView.context.genders;
        this._NgFor_45_6.check_ngForOf(currVal_45_0_0, throwOnChange, false);
        this._NgFor_45_6.ngDoCheck(this, this._anchor_45, throwOnChange);
        this._DefaultValueAccessor_59_3.ngDoCheck(this, this._el_59, throwOnChange);
        var currVal_59_1_0 = '';
        this._RequiredValidator_59_4.check_required(currVal_59_1_0, throwOnChange, false);
        this._RequiredValidator_59_4.ngDoCheck(this, this._el_59, throwOnChange);
        var currVal_59_2_0 = '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?';
        this._PatternValidator_59_5.check_pattern(currVal_59_2_0, throwOnChange, false);
        this._PatternValidator_59_5.ngDoCheck(this, this._el_59, throwOnChange);
        var currVal_59_3_0 = 'email';
        this._NgModel_59_8.check_name(currVal_59_3_0, throwOnChange, false);
        var currVal_59_3_1 = this.parentView.context.player.email;
        this._NgModel_59_8.check_model(currVal_59_3_1, throwOnChange, false);
        this._NgModel_59_8.ngDoCheck(this, this._el_59, throwOnChange);
        this._NgControlStatus_59_10.ngDoCheck(this, this._el_59, throwOnChange);
        var currVal_66_0_0 = this._arr_110('/team');
        this._RouterLink_66_3.check_routerLink(currVal_66_0_0, throwOnChange, false);
        this._RouterLink_66_3.ngDoCheck(this, this._el_66, throwOnChange);
        var currVal_72_0_0 = this.parentView.context.player._id;
        this._NgIf_72_6.check_ngIf(currVal_72_0_0, throwOnChange, false);
        this._NgIf_72_6.ngDoCheck(this, this._anchor_72, throwOnChange);
        this._vc_45.detectChangesInNestedViews(throwOnChange);
        this._vc_72.detectChangesInNestedViews(throwOnChange);
        this._NgControlStatusGroup_0_5.checkHost(this, this, this._el_0, throwOnChange);
        this._RequiredValidator_9_4.checkHost(this, this, this._el_9, throwOnChange);
        this._NgControlStatus_9_9.checkHost(this, this, this._el_9, throwOnChange);
        var currVal_106 = import3.inlineInterpolate(1, '', this.parentView.context.player.name, '');
        if (import3.checkBinding(throwOnChange, this._expr_106, currVal_106)) {
            this.renderer.setText(this._text_13, currVal_106);
            this._expr_106 = currVal_106;
        }
        this._RequiredValidator_23_4.checkHost(this, this, this._el_23, throwOnChange);
        this._NgControlStatus_23_9.checkHost(this, this, this._el_23, throwOnChange);
        var currVal_107 = import3.inlineInterpolate(1, '', this.parentView.context.player.lastName, '');
        if (import3.checkBinding(throwOnChange, this._expr_107, currVal_107)) {
            this.renderer.setText(this._text_27, currVal_107);
            this._expr_107 = currVal_107;
        }
        var currVal_108 = import3.inlineInterpolate(1, '', this.parentView.context.player.gender, '');
        if (import3.checkBinding(throwOnChange, this._expr_108, currVal_108)) {
            this.renderer.setText(this._text_49, currVal_108);
            this._expr_108 = currVal_108;
        }
        this._RequiredValidator_59_4.checkHost(this, this, this._el_59, throwOnChange);
        this._PatternValidator_59_5.checkHost(this, this, this._el_59, throwOnChange);
        this._NgControlStatus_59_10.checkHost(this, this, this._el_59, throwOnChange);
        var currVal_109 = import3.inlineInterpolate(1, '', this.parentView.context.player.email, '');
        if (import3.checkBinding(throwOnChange, this._expr_109, currVal_109)) {
            this.renderer.setText(this._text_63, currVal_109);
            this._expr_109 = currVal_109;
        }
        var currVal_111 = (!this._NgForm_0_3.context.valid || this.parentView.context.disabled);
        if (import3.checkBinding(throwOnChange, this._expr_111, currVal_111)) {
            this.renderer.setElementProperty(this._el_69, 'disabled', currVal_111);
            this._expr_111 = currVal_111;
        }
    };
    View_PlayerEditComponent1.prototype.destroyInternal = function () {
        this._vc_45.destroyNestedViews();
        this._vc_72.destroyNestedViews();
        this._NgModel_9_7.ngOnDestroy();
        this._NgModel_23_7.ngOnDestroy();
        this._NgModel_59_8.ngOnDestroy();
        this._NgForm_0_3.ngOnDestroy();
    };
    View_PlayerEditComponent1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_PlayerEditComponent1.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 45)) {
            return new View_PlayerEditComponent2(this.viewUtils, this, 45, this._anchor_45, this._vc_45);
        }
        if ((nodeIndex == 72)) {
            return new View_PlayerEditComponent3(this.viewUtils, this, 72, this._anchor_72, this._vc_72);
        }
        return null;
    };
    View_PlayerEditComponent1.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._NgForm_0_3.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngSubmit')) {
            var pd_sub_0 = (this.parentView.context.onSubmit(this._NgForm_0_3.context) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    View_PlayerEditComponent1.prototype.handleEvent_9 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_9_3.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            var pd_sub_0 = ((this.parentView.context.player.name = $event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    View_PlayerEditComponent1.prototype.handleEvent_23 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_23_3.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            var pd_sub_0 = ((this.parentView.context.player.lastName = $event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    View_PlayerEditComponent1.prototype.handleEvent_59 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_59_3.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            var pd_sub_0 = ((this.parentView.context.player.email = $event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    View_PlayerEditComponent1.prototype.handleEvent_66 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._RouterLink_66_3.handleEvent(eventName, $event) && result);
        return result;
    };
    return View_PlayerEditComponent1;
}(import2.AppView));
var View_PlayerEditComponent2 = (function (_super) {
    __extends(View_PlayerEditComponent2, _super);
    function View_PlayerEditComponent2(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        _super.call(this, View_PlayerEditComponent2, renderType_PlayerEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways, declaredViewContainer);
        this._expr_10 = import1.UNINITIALIZED;
    }
    View_PlayerEditComponent2.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'label', new import3.InlineArray2(2, 'class', 'radio-inline'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n                ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'input', new import3.InlineArray4(4, 'name', 'gender', 'type', 'radio'), null);
        this._DefaultValueAccessor_2_3 = new import19.Wrapper_DefaultValueAccessor(this.renderer, new import24.ElementRef(this._el_2));
        this._RadioControlValueAccessor_2_4 = new import38.Wrapper_RadioControlValueAccessor(this.renderer, new import24.ElementRef(this._el_2), this.parentView.parentView.injectorGet(import39.RadioControlRegistry, this.parentView.parentIndex), this.injector(2));
        this._NG_VALUE_ACCESSOR_2_5 = [
            this._DefaultValueAccessor_2_3.context,
            this._RadioControlValueAccessor_2_4.context
        ];
        this._NgModel_2_6 = new import21.Wrapper_NgModel(this.parentView._ControlContainer_0_4, null, null, this._NG_VALUE_ACCESSOR_2_5);
        this._NgControl_2_7 = this._NgModel_2_6.context;
        this._NgControlStatus_2_8 = new import18.Wrapper_NgControlStatus(this._NgControl_2_7);
        this._text_3 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_2, new import3.InlineArray8(8, 'ngModelChange', null, 'input', null, 'blur', null, 'change', null), this.eventHandler(this.handleEvent_2));
        this._NgModel_2_6.subscribe(this, this.eventHandler(this.handleEvent_2), true);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3
        ]), [disposable_0]);
        return null;
    };
    View_PlayerEditComponent2.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import27.DefaultValueAccessor) && (2 === requestNodeIndex))) {
            return this._DefaultValueAccessor_2_3.context;
        }
        if (((token === import39.RadioControlValueAccessor) && (2 === requestNodeIndex))) {
            return this._RadioControlValueAccessor_2_4.context;
        }
        if (((token === import30.NG_VALUE_ACCESSOR) && (2 === requestNodeIndex))) {
            return this._NG_VALUE_ACCESSOR_2_5;
        }
        if (((token === import31.NgModel) && (2 === requestNodeIndex))) {
            return this._NgModel_2_6.context;
        }
        if (((token === import32.NgControl) && (2 === requestNodeIndex))) {
            return this._NgControl_2_7;
        }
        if (((token === import33.NgControlStatus) && (2 === requestNodeIndex))) {
            return this._NgControlStatus_2_8.context;
        }
        return notFoundResult;
    };
    View_PlayerEditComponent2.prototype.detectChangesInternal = function (throwOnChange) {
        this._DefaultValueAccessor_2_3.ngDoCheck(this, this._el_2, throwOnChange);
        var currVal_2_1_0 = 'gender';
        this._RadioControlValueAccessor_2_4.check_name(currVal_2_1_0, throwOnChange, false);
        var currVal_2_1_1 = this.context.$implicit;
        this._RadioControlValueAccessor_2_4.check_value(currVal_2_1_1, throwOnChange, false);
        this._RadioControlValueAccessor_2_4.ngDoCheck(this, this._el_2, throwOnChange);
        var currVal_2_2_0 = 'gender';
        this._NgModel_2_6.check_name(currVal_2_2_0, throwOnChange, false);
        var currVal_2_2_1 = this.parentView.parentView.context.player.gender;
        this._NgModel_2_6.check_model(currVal_2_2_1, throwOnChange, false);
        this._NgModel_2_6.ngDoCheck(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_8.ngDoCheck(this, this._el_2, throwOnChange);
        this._NgControlStatus_2_8.checkHost(this, this, this._el_2, throwOnChange);
        var currVal_10 = import3.inlineInterpolate(1, '\n                ', this.context.$implicit, '\n            ');
        if (import3.checkBinding(throwOnChange, this._expr_10, currVal_10)) {
            this.renderer.setText(this._text_3, currVal_10);
            this._expr_10 = currVal_10;
        }
    };
    View_PlayerEditComponent2.prototype.destroyInternal = function () {
        this._RadioControlValueAccessor_2_4.ngOnDestroy();
        this._NgModel_2_6.ngOnDestroy();
    };
    View_PlayerEditComponent2.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_PlayerEditComponent2.prototype.handleEvent_2 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._DefaultValueAccessor_2_3.handleEvent(eventName, $event) && result);
        result = (this._RadioControlValueAccessor_2_4.handleEvent(eventName, $event) && result);
        if ((eventName == 'ngModelChange')) {
            var pd_sub_0 = ((this.parentView.parentView.context.player.gender = $event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_PlayerEditComponent2;
}(import2.AppView));
var View_PlayerEditComponent3 = (function (_super) {
    __extends(View_PlayerEditComponent3, _super);
    function View_PlayerEditComponent3(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        _super.call(this, View_PlayerEditComponent3, renderType_PlayerEditComponent, import7.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways, declaredViewContainer);
        this._expr_2 = import1.UNINITIALIZED;
    }
    View_PlayerEditComponent3.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'button', new import3.InlineArray2(2, 'class', 'btn btn-default pull-right'), null);
        this._text_1 = this.renderer.createText(this._el_0, 'Delete', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1
        ]), [disposable_0]);
        return null;
    };
    View_PlayerEditComponent3.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2 = this.parentView.parentView.context.disabled;
        if (import3.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setElementProperty(this._el_0, 'disabled', currVal_2);
            this._expr_2 = currVal_2;
        }
    };
    View_PlayerEditComponent3.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_PlayerEditComponent3.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.parentView.parentView.context.removePlayer() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_PlayerEditComponent3;
}(import2.AppView));
//# sourceMappingURL=player-edit.component.ngfactory.js.map